// extracted by mini-css-extract-plugin
export default {"transactionCard":"TransactionCard_transactionCard__HfKwN","transactionInfo":"TransactionCard_transactionInfo__ZhnFS","transactionTime":"TransactionCard_transactionTime__Js50J"};